import React, { useState, useEffect } from 'react';
import { CommonModalProps } from './Types';
import { Modal, TextInput } from '@wajeez-web/components/ui';

const PromoCodeModal: React.FC<CommonModalProps<{ Code: string }>> = ({
  isOpen,
  onClose,
  data,
  onSubmit,
}) => {
  const [promoCode, setPromoCode] = useState<{ Code: string }>({ Code: '' });

  useEffect(() => {
    data ? setPromoCode({ ...data }) : setPromoCode({ Code: '' });
  }, [data]);

  const handleChange = (name: string, value: any) => {
    setPromoCode({ ...promoCode, [name]: value });
  };

  return (
    <Modal
      title={'Promo Code'}
      open={isOpen}
      onClose={onClose}
      withScroll={true}
      onSubmit={() => {
        onSubmit && onSubmit(promoCode);
      }}
    >
      <div className="space-y-3">
        <TextInput
          label="Code"
          name="Code"
          value={promoCode.Code}
          onChange={handleChange}
          required={true}
        />
      </div>
    </Modal>
  );
};

export default PromoCodeModal;
